import FullscreenMessage from './FullscreenMessage.vue';
export default FullscreenMessage;
